import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { IconButton } from "@mui/material";
import React, { useState } from "react";

import MDTypography from "@/components/atoms/MDTypography";
import { TableCell, TableRow } from "@/components/molecules/Table/styled";
import useCampaignLogData from "@/hooks/data/use-campaign-log-data";
import { ICampaignLog } from "@/interfaces/campaign-logs.interface";
import { CampaignLogsMessages } from "@/messages/campaigns/logs/campaign-logs.messages";

interface Props {
  log: ICampaignLog;
  index: number;
  messages: CampaignLogsMessages;
}

export function CampaignLogTableRow({ log, index, messages }: Props) {
  const [isExpanded, setIsExpanded] = useState(false);
  const campaignLogData = useCampaignLogData({ log, messages });

  return (
    <>
      <TableRow index={index} key={log.id}>
        <TableCell>
          <IconButton onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{campaignLogData.formattedDate}</TableCell>
        <TableCell>{campaignLogData.formattedStatus}</TableCell>
        <TableCell>{campaignLogData.formattedContactName}</TableCell>
        <TableCell>{campaignLogData.formattedPhone}</TableCell>
        <TableCell>{campaignLogData.formattedErrorMessage}</TableCell>
      </TableRow>

      {isExpanded &&
        campaignLogData.formattedDetails.map((detail, detailIndex) => (
          <TableRow key={`${log.id}-detail-${detailIndex}`} index={index + detailIndex + 1}>
            <TableCell colSpan={1}></TableCell>
            <TableCell>
              <MDTypography variant="body2" color="text" fontWeight={"bold"}>
                {detail.formattedMessageDate}
              </MDTypography>
            </TableCell>
            <TableCell>
              <MDTypography variant="body2" color="text" fontWeight={"bold"}>
                {detail.formattedMessageStatus}
              </MDTypography>
            </TableCell>
            <TableCell colSpan={2}></TableCell>

            <TableCell>
              <MDTypography variant="body2" color="text" fontWeight={"bold"}>
                {detail.formattedErrorMessage}
              </MDTypography>
            </TableCell>
          </TableRow>
        ))}
    </>
  );
}
